import React, { useContext } from 'react';

const AppContext = React.createContext();

const useGlobalContext = () => {
  return useContext(AppContext);
};

const AppProvider = ({ children }) => {
  const [answerStates, setAnswerStates] = React.useState([
    'normal',
    'normal',
    'normal',
    'normal',
  ]);

  const [score, setScore] = React.useState(
    localStorage.getItem('score')
      ? JSON.parse(localStorage.getItem('score'))
      : 0
  );

  const [data, setData] = React.useState(null);
  //  console.log(JSON.parse(localStorage.getItem('score')));
  //  console.log(localStorage.getItem('userInfo'));

  //localStorage.clear();
  /*
  function tryParseJSONObject(jsonString) {
    try {
      var o = JSON.parse(jsonString);

      if (o && typeof o === 'object') {
        console.log(typeof o);

        return o;
      }
    } catch (e) {
      console.log(e);
    }

    return false;
  } */

  // tryParseJSONObject(localStorage.getItem('userInfo'));

  const [lessonState, setLessonState] = React.useState(
    localStorage.getItem('lessons')
      ? JSON.parse(localStorage.getItem('lessons'))
      : 0
  );

  const [userInfo, setUserInfo] = React.useState(
    localStorage.getItem('userInfo')
      ? JSON.parse(localStorage.getItem('userInfo'))
      : null
  );

  return (
    <AppContext.Provider
      value={{
        answerStates,
        setAnswerStates,
        score,
        setScore,
        lessonState,
        setLessonState,
        userInfo,
        setUserInfo,
        data,
        setData,
      }}
    >
      {' '}
      {children}{' '}
    </AppContext.Provider>
  );
};

export { useGlobalContext, AppProvider };
